import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import qs, { IParseOptions } from 'qs'

const defaultOptions: IParseOptions = { ignoreQueryPrefix: true }

export default function useQuery(options = defaultOptions) {
  const { search } = useLocation()

  return useMemo(() => qs.parse(search, options), [options, search])
}
